import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';

export default class PastBillsView extends Component {
  
    render(){
  
      return (
        <nav className="navbar navbar-expand-sm navbar-light">
        <ul className="navbar-nav container">
          <li className="nav-item">
            <NavLink exact className="nav-link sign-nav" activeClassName="active" to="/pastbills/water">Water</NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link sign-nav" activeClassName="active" to='/pastbills/electricity'>Electricity</NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link sign-nav" activeClassName="active" to="/pastbills/gas">Gas</NavLink>
          </li>
        </ul>
      </nav>
      )
    }
  }